/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'feedback-collector.anonymous': 'このフィードバックは匿名で提出されます。このフィードバックについて、アトラシアンがお客様に直接連絡を取ることはできません。',
  'feedback-collector.anonymous.title': '匿名のフィードバック',
  'feedback-collector.can-be-contacted.label': 'はい、アトラシアンの製品とサービスの向上のために、アトラシアンのチームから利用体験に関する問い合わせを受け取ることを了承します。<a>アトラシアンのプライバシー ポリシー</a>に同意します。',
  'feedback-collector.cancel-button.label': 'キャンセル',
  'feedback-collector.default.custom.textarea.label': 'ご意見をお聞かせください。',
  'feedback-collector.enrol-in-research.label': '製品調査に参加する',
  'feedback-collector.feedback-title': 'ご意見をお聞かせください',
  'feedback-collector.form.bug.label': 'バグまたは課題の説明をご入力ください。',
  'feedback-collector.form.comment.label': '具体的な内容をご入力ください。',
  'feedback-collector.form.empty.label': 'オプションを選択',
  'feedback-collector.form.question.label': 'ご質問を教えてください',
  'feedback-collector.form.suggestion.label': '改良を希望する点をご入力ください。',
  'feedback-collector.option.bug.label': 'バグを報告する',
  'feedback-collector.option.comment.label': 'コメントを残す',
  'feedback-collector.option.default.label': 'フィードバックを選択してください',
  'feedback-collector.option.default.placeholder': '1 つ選択',
  'feedback-collector.option.question.label': '質問する',
  'feedback-collector.option.suggestion.label': '改良点を提案する',
  'feedback-collector.required.fields.summary': '必須フィールドにはアスタリスクが付いています',
  'feedback-collector.submit-button.label': 'フィードバックを送信',
  'feedback-collector.success-flag.description': 'お寄せいただいた貴重なフィードバックは、製品のさらなる改善に役立てさせていただきます。',
  'feedback-collector.success-flag.title': 'よろしくお願いいたします。',
  'feedback-collector.summary-placeholder': '具体的な内容をご入力ください。',
  'proforma-form-builder.feedback-icon-label': 'フィードバック',
  'proforma-form-builder.give-feedback': 'フィードバックを送信'
};